import React from "react";

/**
 * Delete confirmation component for Art Pack
 * Displays a confirmation dialog before deleting an art pack
 */
const Delete = ({ formData, onDiscard, handleSubmit }) => {
  const artPackName = formData?.art_pack_name || "this item";

  return (
    <div className="container form-group text-center text-secondary col-sm-8 pt-5">
      <h3 className="row justify-content-md-center">
        Are you sure you want to delete this record?{" "}
        <b>
          <u>{artPackName}</u>
        </b>
      </h3>

      <div className="mt-4">
        <input
          type="button"
          value="Yes"
          className="btn bg-orange form-btn"
          onClick={handleSubmit}
          aria-label={`Confirm delete ${artPackName}`}
        />
        <button
          type="button"
          className="btn btn-secondary form-btn mx-3"
          onClick={onDiscard}
          aria-label="Cancel delete"
        >
          No
        </button>
      </div>
    </div>
  );
};

export default Delete;
